import EntryActionTypes from '../constants/EntryActionTypes';

const fetchContentTypeTemplates = () => ({
  type: EntryActionTypes.CONTENT_TYPE_TEMPLATES_FETCH,
});

const createContentTypeTemplate = (data) => ({
  type: EntryActionTypes.CONTENT_TYPE_TEMPLATE_CREATE,
  payload: {
    data,
  },
});

const updateContentTypeTemplate = (id, data) => ({
  type: EntryActionTypes.CONTENT_TYPE_TEMPLATE_UPDATE,
  payload: {
    id,
    data,
  },
});

const deleteContentTypeTemplate = (id) => ({
  type: EntryActionTypes.CONTENT_TYPE_TEMPLATE_DELETE,
  payload: {
    id,
  },
});

const createContentTypeTemplateItem = (templateId, data) => ({
  type: EntryActionTypes.CONTENT_TYPE_TEMPLATE_ITEM_CREATE,
  payload: {
    templateId,
    data,
  },
});

const updateContentTypeTemplateItem = (id, data) => ({
  type: EntryActionTypes.CONTENT_TYPE_TEMPLATE_ITEM_UPDATE,
  payload: {
    id,
    data,
  },
});

const deleteContentTypeTemplateItem = (id) => ({
  type: EntryActionTypes.CONTENT_TYPE_TEMPLATE_ITEM_DELETE,
  payload: {
    id,
  },
});

const fetchContentTypesInCurrentBoard = () => ({
  type: EntryActionTypes.CONTENT_TYPES_IN_CURRENT_BOARD_FETCH,
});

const createContentTypeInCurrentBoard = (data) => ({
  type: EntryActionTypes.CONTENT_TYPE_IN_CURRENT_BOARD_CREATE,
  payload: {
    data,
  },
});

const updateContentType = (id, data) => ({
  type: EntryActionTypes.CONTENT_TYPE_UPDATE,
  payload: {
    id,
    data,
  },
});

const deleteContentType = (id) => ({
  type: EntryActionTypes.CONTENT_TYPE_DELETE,
  payload: {
    id,
  },
});

const applyContentTypeTemplateInCurrentBoard = (templateId) => ({
  type: EntryActionTypes.CONTENT_TYPE_TEMPLATE_IN_CURRENT_BOARD_APPLY,
  payload: {
    templateId,
  },
});

export default {
  fetchContentTypeTemplates,
  createContentTypeTemplate,
  updateContentTypeTemplate,
  deleteContentTypeTemplate,
  createContentTypeTemplateItem,
  updateContentTypeTemplateItem,
  deleteContentTypeTemplateItem,
  fetchContentTypesInCurrentBoard,
  createContentTypeInCurrentBoard,
  updateContentType,
  deleteContentType,
  applyContentTypeTemplateInCurrentBoard,
};
